const TTableQrCodeModal = {
    // English
    "enUS": {
        'DOWNLOAD_ALL': 'Download all',
        'TABLE': 'Table',
        'GENERATING_QR_CODES': 'Generating QR codes... This can take a couple of seconds',
        'COMPRESSING': 'Compressing... This can take a couple of seconds',
        'DOWNLOADING': 'Downloading... Check your notifications or your downloads folder',
    },
    // Spanish
    "esMX": {
        'DOWNLOAD_ALL': 'Descargar todos',
        'TABLE': 'Mesa',
        'GENERATING_QR_CODES': 'Generando códigos QR... Esto puede demorar unos segundos',
        'COMPRESSING': 'Comprimiendo... Esto puede demorar unos segundos',
        'DOWNLOADING': 'Descargando... Checa tus notificaciones o tu carpeta de descarga',
    }
}
export default TTableQrCodeModal;